import {
    LOG_IN,
    LOG_OUT,
    SHOW_LOGIN_DIALOG,
    CANCEL_LOGIN_DIALOG,
    SESSION_INITIALIZED,
    LOG_OUT_SUCCESS,
    CLOSE_LOGIN_DIALOG,
    LOG_IN_SUCCESS,
    LOG_IN_FAIL,
    EXTEND_SESSION_SUCCESS,
    EXTEND_SESSION,
    FORGOT_PASSWORD,
    CHANGE_PASSWORD,
    CHANGE_PASSWORD_FAILURE,
    CHANGE_PASSWORD_SUCCESS,
    RESET_CHANGE_PASSWORD_FORM,
    ACTIVATE_ACCOUNT,
    RESET_USER_PASSWORD,
    RESET_USER_PASSWORD_SUCCESS,
    RESET_USER_PASSWORD_FAILED, RESET_FORGOT_PASSWORD_FORM,
} from './SessionActionTypes';
import jwtDecode from 'jwt-decode';
import {errorMessage} from "../../../components/AjaxHelpers";

export const logIn = (username, password) => ({
    type: LOG_IN,
    username,
    password,
})

export const extendSession = () => ({
    type: EXTEND_SESSION,
})

export const activationSucceeded = (jwt, username, expiresUTC) => {
    // Same flow here as when we log in since successful activation returns a jwt
    return logInSucceeded(jwt,username,expiresUTC);
}

export const activationFailed = (error) => {
    // Same error handling as when we are changing passwords
    return changePasswordFailed(error);
}

export const forgotPassword = (email) => ({
    type: FORGOT_PASSWORD,
    email
})
export const resetForgotPasswordForm = () => ({
    type: RESET_FORGOT_PASSWORD_FORM,
})
export const resetUserPassword = (email) => ({
    type: RESET_USER_PASSWORD,
    email
})
export const resetUserPasswordSuccess = () => ({
    type: RESET_USER_PASSWORD_SUCCESS,
})
export const resetUserPasswordFailed = (error) => ({
    type: RESET_USER_PASSWORD_FAILED,
    error
})

export const logInSucceeded = (jwt, username, expiresUTC) => {
    let decodedRolesString = jwtDecode(jwt).roles;
    let roles = decodedRolesString && decodedRolesString.length > 0 ? decodedRolesString.trim().split(","): [];
    let organizationId = jwtDecode(jwt).organizationId;
    if (organizationId === 'undefined' || typeof organizationId === 'undefined') {
        organizationId = null;
    }
    let organizationName = jwtDecode(jwt).organizationName;
    if (organizationName === 'undefined' || typeof organizationName === 'undefined') {
        organizationName = null;
    }
    return ({
        type: LOG_IN_SUCCESS,
            auth: {
            jwt,
            username,
            organizationId,
            organizationName,
            expiresUTC,
            roles,
        }
    })
}

export const extendSessionSucceeded = (jwt, username, expiresUTC) => {
    let decodedRolesString = jwtDecode(jwt).roles;
    let roles = decodedRolesString && decodedRolesString.length > 0 ? decodedRolesString.trim().split(","): [];
    let organizationId = jwtDecode(jwt).organizationId;
    if (organizationId === 'undefined' || typeof organizationId === 'undefined') {
        organizationId = null;
    }
    let organizationName = jwtDecode(jwt).organizationName;
    if (organizationName === 'undefined' || typeof organizationName === 'undefined') {
        organizationName = null;
    }

    return ({
        type: EXTEND_SESSION_SUCCESS,
        auth: {
            jwt,
            username,
            organizationId,
            organizationName,
            expiresUTC,
            roles,
        }
    })
}

export const logInFailed = (error) => {
    return ({
        type: LOG_IN_FAIL,
        error
    })
}

export const logOut = () => ({
    type: LOG_OUT,
})

export const logOutSucceeded = (username, reason) => ({
    type: LOG_OUT_SUCCESS,
    username,
    reason,
})

export const showLoginDialog = () => ({
    type: SHOW_LOGIN_DIALOG,
})

export const cancelLoginDialog = () => ({
    type: CANCEL_LOGIN_DIALOG,
})

export const closeLoginDialog = () => ({
    type: CLOSE_LOGIN_DIALOG,
})

export const sessionInitialized = (user, roles) => ({
    type: SESSION_INITIALIZED,
    user,
    roles
})

export const changePassword = (username, currentPassword, newPassword, newPasswordRetype) => ({
    type: CHANGE_PASSWORD,
    username,
    currentPassword,
    newPassword,
    newPasswordRetype,
})

export const activateAccount = (username, oneTimePassword, newPassword, newPasswordRetype) => ({
    type: ACTIVATE_ACCOUNT,
    username,
    oneTimePassword,
    newPassword,
    newPasswordRetype,
})

export const changePasswordSucceeded = () => ({
    type: CHANGE_PASSWORD_SUCCESS,
})
export const changePasswordFailed = (error) => ({
    type: CHANGE_PASSWORD_FAILURE,
    errorMessage: errorMessage(error, 'Fel vid försök att byta lösenord'),
})

export const resetChangePasswordForm = () => ({
    type: RESET_CHANGE_PASSWORD_FORM,
})
